module.exports = __webpack_public_path__ + "img/HT.25319976.png";